import Component from './lottery_page_table.vue'
export default Component
